


import i18next from 'i18next';
import { Col, Row } from 'react-bootstrap';
import { StellantisQuoteRequestDTO } from 'src/api/models/StellantisDTO';
import QuoteRequestDiff from './QuoteRequestDiff';

type Props = {
  dto: StellantisQuoteRequestDTO;
};

const QuoteRequestExpand: React.FC<Props> = ({ dto }) => {

  const dataProperties = {
    [i18next.t('rca')]: dto.quote?.rcaPenaleRisarcitoria + '€',
    [i18next.t('theft_fire')]: dto.quote?.incendioFurtoScopertoPerc + '%',
    [i18next.t('kasko')]: dto.quote?.kaskoFranchigia + '€',
    [i18next.t('tyres')]: dto.quote?.gommeYN ? i18next.t('yes') : i18next.t('no'),
    ...(dto.quote?.gommeYN
      ? {
        [i18next.t('tipo_gomma')]: dto.quote?.tipoGomma?.toUpperCase(),
        [i18next.t('n_treno_gomme_estive')]: dto.quote?.numTrenoGommeEstive,
        [i18next.t('n_treno_gomme_invernali')]: dto.quote?.numTrenoGommeInvernali,
        [i18next.t('gomme_illimitate_YN')]: dto.quote?.gommeIllimitateYN ? i18next.t('yes') : i18next.t('no'),
      }
      : {})
    ,
    [i18next.t('replacement_car')]: dto.quote?.autoSostitutivaYN ? i18next.t('yes') : i18next.t('no'),
    ...(dto.quote?.autoSostitutivaYN
      ? { [i18next.t('auto_sostitutiva_gruppo')]: dto.quote?.autoSostitutivaGruppo?.toUpperCase(), }
      : {}
    )
  };

  return (
    <div className="property-grid">
      <Row>
        {Object.entries(dataProperties).map(([key, value]) => (
          <Col xs={12} sm={6} md={4} lg={3} key={key} className="property-item">
            <div>
              <label className="property-label">{key}</label>
              <div className="property-value">{value ?? 'N/A'}</div>
            </div>
          </Col>
        ))}
      </Row>
      <Row className="mt-2">
        <QuoteRequestDiff dto={dto} />
      </Row>
    </div>
  )

};

export default QuoteRequestExpand;
